import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Left from "../assets/images/left.png";
import logo from "../assets/images/logo.png";
import Shop from "../assets/images/shop.png";
import Menu from "../assets/images/menu.png";
import Dropdown from "react-bootstrap/Dropdown";
import { FilterOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Drawer, Form, Input, Row, Select, Space } from 'antd'
import Title from "antd/es/typography/Title";
import http from "../services/http";


const { Option } = Select;

const filterObject = {
    team_id: null,
    group_id: null,
    swimmer_id: null,
    stroke_id: null,
    year: null,
    month: null
}
export default function Filter(props) {
    const token = localStorage.getItem("xAuthToken");
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [teams, setTeams] = useState([]);
    const [swimmers, setSwimmers] = useState([]);
    const [groupsByTeams, setGroupsByTeams] = useState([]);
    const [strokes, setStrokes] = useState([]);
    const [swimmerId, setSwimmerId] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadTeams();
        loadStrokes();
    }, []);

    useEffect(() => { }, [swimmers])

    const loadTeams = () => {
        http
            .get(`api/admin/team?token=${token}`)
            .then((res) => {
                setTeams(res.data);

                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    };


    const loadSwimmer = () => {
        http
            .get(`api/swimmer/getbyteam/${filterObject.team_id}?token=${token}`)
            .then((res) => {
                setSwimmers(res.data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }

    const loadGroupByTeam = () => {
        http
            .get(`api/admin/teamgroup/byteam/${filterObject.team_id}?token=${token}`)
            .then((res) => {
                setGroupsByTeams(res.data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    const loadStrokes = () => {
        http
            .get(`api/category?token=${token}`)
            .then((res) => {
                setStrokes(res.data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
        props.onFilterApply?.(filterObject);

    };

    const onChange = (key, e) => {
        filterObject[key] = e
        if (key === 'team_id') {
            loadSwimmer(e)
            loadGroupByTeam(e)
        }
    };

    const filterOption = (input, option) => {
        console.log(option)
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    }
    return (
        <>
            <div className="custom_container ">
                <div className="login_logo  mb_40">
                    <div onClick={showDrawer} style={{ cursor: 'pointer' }}>
                        <Row gutter={16}>
                            <Col >
                                <FilterOutlined style={{ fontSize: '30px', marginTop: '4px', color: '#0f4e9b' }} />
                            </Col>
                            <Col >
                                <Title level={3}>Filter</Title>
                            </Col>
                        </Row>
                    </div>

                    <Drawer
                        title="Filter"
                        width={500}
                        onClose={onClose}
                        open={open}
                        styles={{
                            body: {
                                paddingBottom: 80,
                            },
                        }}
                        extra={
                            <Space>
                                <Button onClick={onClose}>Cancel</Button>
                                <Button onClick={onClose} type="primary">
                                    Apply
                                </Button>
                            </Space>
                        }
                    >
                        <Form layout="vertical" hideRequiredMark>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        name="team"
                                        label="Team"
                                        rules={[{ required: true, message: 'Please select team' }]}
                                    >
                                        <Select allowClear onChange={(val) => {
                                            onChange("team_id", val)
                                        }} showSearch placeholder="Please select team">
                                            {teams?.map((item, i) => (
                                                <option key={i} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name="swimmer"
                                        label="Swimmer"
                                    >
                                        <Select allowClear defaultValue="" onChange={(val) => {
                                            onChange("swimmer_id", val)
                                        }} showSearch placeholder="Please select swimmer">
                                            {swimmers?.map((item, i) => (
                                                <option key={i} value={item.id}>
                                                    {item.firstname} {item.lastname}
                                                </option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        name="group"
                                        label="Group"
                                    >
                                        <Select allowClear onChange={(val) => {
                                            onChange("group_id", val)
                                        }} showSearch placeholder="Please select group">
                                            {groupsByTeams?.map((item, i) => (
                                                <option key={i} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name="stroke"
                                        label="Stroke"
                                    >
                                        <Select allowClear onChange={(val) => {
                                            onChange("stroke_id", val)
                                        }} placeholder="Please select stroke">
                                            {strokes?.map((item, i) => (
                                                <option key={i} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        name="year"
                                        label="Year"
                                    >
                                        <DatePicker onChange={(date, val) => { onChange("year", val) }} picker="year" />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name="month"
                                        label="Month"
                                    >
                                        <DatePicker onChange={(date, val) => { onChange("month", val) }} picker="month" format={"MM"} />
                                    </Form.Item>
                                </Col>
                            </Row>

                        </Form>
                    </Drawer>
                </div>
            </div>
        </>
    );
}
